import React, { useEffect, useState } from "react";
import styles from "./MediaPlayer.module.css";

const LOCAL_STORAGE_KEY = "mediaPlayerClosed";

const MediaPlayerModal = () => {
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    const closed = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (closed === "true") setIsOpen(false);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    localStorage.setItem(LOCAL_STORAGE_KEY, "true");
  };

  if (!isOpen) return null;

  return (
    <div className={styles["media-player-modal"]}>
      <button
        onClick={handleClose}
        className={styles["media-player-close-btn"]}
        aria-label="Close"
      >
        &times;
      </button>
      <div className={styles["video-container"]}>
        <iframe
          src="https://www.loom.com/embed/68689e4797914239b174cc9f6dc1e7da?sid=77248003-e422-4978-93bf-50d05020e417"
          frameBorder="0"
          allowFullScreen
          title="Loom Video"
        />
      </div>
    </div>
  );
};

export default MediaPlayerModal;
